// extracted by mini-css-extract-plugin
export default {"forgot_pswd_row":"EmailLogin_forgot_pswd_row__uYKSK","btn_forgot_password":"EmailLogin_btn_forgot_password__Pr5d3"};